/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rhythm_BodyInputs */

const en_portal_rhythm_body = /** @type {(inputs: Portal_Rhythm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You tell your coach what you're after. They set the plan, the calories and the sessions, and you see all of it in one app.`)
};

const pl_portal_rhythm_body = /** @type {(inputs: Portal_Rhythm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mówisz trenerowi, do czego dążysz. On ustawia plan, kalorie i terminy, a Ty widzisz wszystko w jednej aplikacji.`)
};

/**
* | output |
* | --- |
* | "You tell your coach what you're after. They set the plan, the calories and the sessions, and you see all of it in one app." |
*
* @param {Portal_Rhythm_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rhythm_body = /** @type {((inputs?: Portal_Rhythm_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rhythm_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rhythm_body(inputs)
	return en_portal_rhythm_body(inputs)
});